import { loanFeeRecommendationsApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_FEE_RECOMMENDATIONS_ACTION_TYPE = createNamedActions(
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/feeRecommendations`,
  {
    GET_FEE_RECOMMENDATIONS: 'GET_FEE_RECOMMENDATIONS',
  },
);

export const getLoanFeeRecommendationsAction = catchAsyncActionError(
  ({ loanId }) =>
    async dispatch => {
      const { data } = await loanFeeRecommendationsApi.getRecommendations({ loanId });

      return dispatch({
        type: LOAN_FEE_RECOMMENDATIONS_ACTION_TYPE.GET_FEE_RECOMMENDATIONS,
        payload: data,
      });
    },
);

export const acceptLoanFeeRecommendationItemAction = catchAsyncActionError(
  ({ loanId, itemId }) =>
    async () => {
      await loanFeeRecommendationsApi.acceptItem({ loanId, itemId });
    },
);

export const rejectLoanFeeRecommendationItemAction = catchAsyncActionError(
  ({ loanId, itemId, reviewNotes }) =>
    async () => {
      await loanFeeRecommendationsApi.rejectItem({ loanId, itemId, reviewNotes });
    },
);

export const acceptAllLoanFeeRecommendationsAction = catchAsyncActionError(
  ({ loanId, sessionId, itemIds }) =>
    async () => {
      await loanFeeRecommendationsApi.acceptAll({ loanId, sessionId, itemIds });
    },
);

export const rejectAllLoanFeeRecommendationsAction = catchAsyncActionError(
  ({ loanId, sessionId, reviewNotes }) =>
    async () => {
      await loanFeeRecommendationsApi.rejectAll({ loanId, sessionId, reviewNotes });
    },
);
